import React from "react"
import { Link } from "gatsby"
import { FaBriefcase } from "react-icons/fa"
import { useLanguage } from "../contexts/LanguageContext"

const JobCTA = () => {
  const { selectedLanguage } = useLanguage()

  return (
    <section className="job-cta-section bg-silver-grey">
      <div className="section-center job-cta-wrapper">
        <div className="job-cta-icon-col">
          <FaBriefcase className="job-cta-icon" />
        </div>
        <div className="job-cta-text-col">
          <h3 className="job-cta-title">
            {selectedLanguage === "EN" ? "We're Hiring" : "Pridruži nam se"}
          </h3>
          <div className="underline job-cta-underline"></div>
          <p className="job-cta-text">
            {selectedLanguage === "EN"
              ? "We are always on the lookout for talented and motivated people. Apply and become part of the Osijek-Koteks team."
              : "Uvijek tražimo talentirane i motivirane ljude. Prijavi se i postani dio Osijek-Koteks tima."}
          </p>
        </div>
        <div className="job-cta-btn-col">
          <Link to="/o-nama/posao" className="job-cta-btn">
            {selectedLanguage === "EN" ? "Apply now" : "Prijavi se"}
          </Link>
        </div>
      </div>
    </section>
  )
}

export default JobCTA
